<template>
  <v-select
    label='Visibility'
    key="visibility"
    class="white"
    :items="data"
    item-text="name"
    item-value="key"
    v-model="inputVal"
  ></v-select>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["value"],
  data: () => ({
    data: [
      {
        name:"Private",
        key:"private"
      },
       {
        name:"Public",
        key:"public"
      }
    ],
    code: null,
    item: null,
  }),
  created() {
  
  },
  computed: {
    ...mapState({
      school: (state) => state.school.data,
    }),
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
   
  },
  beforeMount() {
  },
};
</script>
